module.exports = __webpack_public_path__ + "img/a790dce37c334f3044db54a4d21cd6f1.ef43616e.png";